import HttpUrl from './httpUrl';
import CONSTANT_URL from './ConstantUrl';

const httpUrl = new HttpUrl();
export { httpUrl, HttpUrl, CONSTANT_URL };
